let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eNry3")).then(() => parcelRequire('l5c5e'));